/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable @next/next/no-img-element */
import Typography from '@common_typography';
import { formatPrice } from '@helpers/currency';
import { currencyVar } from '@core/services/graphql/cache';
import Radio from '@common_forms/Radio';
import classNames from 'classnames';
import MidtransCoreApi from '@core_modules/checkout/components/midtransCoreAPI';
import Thumbor from '@common_image';
import TextField from '@common_forms/TextField';
import { useDispatch, useSelector } from 'react-redux';
import {
    setCashtag as setCashtagState, setCashtagError, selectCheckoutState,
} from '@core_modules/checkout/redux/checkoutSlice';
import gqlService from '@core_modules/checkout/services/graphql';
import Skeleton from '@common/Skeleton';
import { getCmsBlocksLazy } from '@core_modules/theme/services/graphql';
import { getCmsBlocks } from '@core_modules/cms/services/graphql';
import CmsRenderer from '@core_modules/cms/components/cms-renderer';

const RadioDeliveryItem = (props) => {
    const {
        value,
        label,
        promoLabel,
        selected,
        onChange = () => {},
        image = null,
        classContent = '',
        amount,
        price_incl_tax,
        storeConfig,
        disabled = false,
        id,
        name,
        code,
        // isPaymentMethod = false,
        term_options = [],
        onValuesCardChange = () => {},
        onErrorCard = () => {},
        logo,
        form_message,
        carrier_code,
        carrier_title,
        method_title,
        available = 'true',
        __typename,
    } = props;

    const isCoreApi = code?.match(/coreapi_/);
    const isCoreApiXendit = code?.match(/coreapixendit_/);
    const isCreditCard = code?.match(/_cc/);
    const isAllBank = code?.match(/_allbank/);
    const isJeniusPay = code?.match(/jeniuspay/);
    const isPaylater = code?.match(/_paylater/);

    const checkout = useSelector(selectCheckoutState);
    const cartId = checkout.data.cart.id;

    const [createPaylaterPlans] = gqlService.createPaylaterPlans();
    const [paylaterPlans, setPaylaterPlans] = React.useState('');
    const [loadingPlans, setLoadingPlans] = React.useState(true);

    const isGosend = carrier_code?.match(/gosend/);
    const isShippingMethodAvailable = available;

    const isShipping = __typename === 'AvailableShippingMethod';
    const isPaymentMethod = __typename === 'AvailablePaymentMethod';
    const [getCmsBlock, { data, loading, error }] = getCmsBlocksLazy();

    let identifier = '';
    if (isShipping && carrier_title && method_title && isGosend) {
        const carrierTitle = carrier_title?.toLowerCase() || '';
        const methodTitle = method_title?.toLowerCase() || '';
        identifier = `shipment_notes_${carrierTitle}_${methodTitle}`.replace(/[-\s]/g, '_').replace(/_+/g, '_');
    }

    React.useState(() => {
        if (isShipping && identifier && isGosend) {
            getCmsBlock({
                variables: { identifiers: [identifier] },
            });
        }
    }, [isShipping]);

    const identifierInfoGosend = 'gosend-info-shipping';
    const {
        data: dataInfoGosendShipping,
        loading: loadingInfoGosendShipping,
    } = getCmsBlocks({ identifiers: [identifierInfoGosend] });

    const dispatch = useDispatch();

    const handleChange = () => {
        if (!disabled) {
            onChange(value);
        }
    };

    const base_url_logo = `${storeConfig?.base_url}media/logo/paymentmethod/`;

    const isLogoExist = (imageUrl) => {
        if (imageUrl !== base_url_logo) {
            return true;
        }

        return false;
    };

    const [cashtag, setCashtag] = React.useState('');

    const handleChangeCashTag = (e) => {
        const cashtagValue = e?.target?.value;
        setCashtag(cashtagValue.replace(/^(?!\$)/, '$'));
        dispatch(setCashtagState(cashtagValue));

        if (cashtagValue) {
            dispatch(setCashtagError(false));
        } else {
            dispatch(setCashtagError(true));
        }
    };
    // const [cardData, setCardData] = React.useState({});
    // const onValuesChange = (values) => {
    //     setCardData(values);
    // };

    // const [errorCard, setErrorCard] = React.useState({});
    // const onError = (error) => {
    //     setErrorCard(error);
    // };

    // cache currency
    const currencyCache = currencyVar();

    const labelType = selected ? 'bold' : 'regular';
    let rightSide;

    if (image) {
        // eslint-disable-next-line @next/next/no-img-element
        rightSide = <img src={image} className="max-w-[50px] max-h-[25px] right-0" alt="cimb" />;
    }
    const base_currency_code = storeConfig ? storeConfig.base_currency_code : 'RP';
    if (amount && price_incl_tax && price_incl_tax.value > amount.value) {
        rightSide = (
            <div className="flex flex-row between-xs">
                <div className="xs:basis-full sm:basis-1/2">
                    <Typography type={labelType} className="line-through text-right">
                        {formatPrice(price_incl_tax.value, amount.currency, currencyCache || base_currency_code, currencyCache)}
                    </Typography>
                </div>
                <div className="xs:basis-full sm:basis-1/2">
                    <Typography type={labelType} className="ml-auto font-bold text-right">
                        {formatPrice(amount.value, amount.currency, currencyCache || base_currency_code, currencyCache)}
                    </Typography>
                </div>
            </div>
        );
    } else if (price_incl_tax && price_incl_tax.value) {
        rightSide = (
            <div className="flex flex-row">
                <div className="xs:basis-full sm:basis-1/2">
                    <Typography vtype={labelType} className="ml-auto font-normal text-right">
                        {formatPrice(price_incl_tax.value, amount.currency, currencyCache || base_currency_code, currencyCache)}
                    </Typography>
                </div>
            </div>
        );
    } else if (price_incl_tax && price_incl_tax.value === 0 && amount && amount.value === 0) {
        rightSide = (
            <div className="flex flex-row">
                <div className="xs:basis-full sm:basis-1/2">
                    <Typography variant="bd-2" type={labelType} className="ml-auto font-bold text-right">
                        {price_incl_tax.value !== 0 ? formatPrice(price_incl_tax.value, amount.currency, currencyCache
                            || base_currency_code, currencyCache) : 'FREE'}
                    </Typography>
                </div>
            </div>
        );
    }

    const shippingLabel = (
        <div className="inline">
            <div style={{ display: 'contents', alignItems: 'center' }}>
                <Typography type={labelType} className="font-semibold !text-neutral-black !text-[15px]">
                    {label}
                </Typography>
            </div>
            {promoLabel ? (
                <Typography type={labelType}>
                    (
                    {promoLabel}
                    )
                </Typography>
            ) : null}
        </div>
    );

    const itemId = id || `${label}_${value}_${Math.random(Date.now())}`.replace(/ /g, '_');

    React.useEffect(() => {
        if (selected && code && isPaylater) {
            setLoadingPlans(true);
            setPaylaterPlans('');
            createPaylaterPlans({
                variables: {
                    cartId,
                    payment_code: code,
                },
            }).then((res) => {
                setPaylaterPlans(res?.data);
                setLoadingPlans(false);
            }).catch((e) => {
                setLoadingPlans(false);
                window.toastMessage({
                    open: true,
                    variant: 'error',
                    text: e?.message,
                });
            });
        }
    }, [selected]);

    return (
        <div className={`fieldset-wrapper flex flex-col mb-6 ${itemId}`}>
            <div className="swift-checkoutRadioItem items-center flex flex-row">
                <Radio
                    color="default"
                    size="sm"
                    variant="single"
                    checked={selected}
                    onClick={handleChange}
                    className="flex-[0_0_auto] flex items-center justify-center"
                    classNames={{
                        radioClasses: classNames(
                            'cursor-pointer',
                            disabled ? '!border-neutral-500 focus:!border-500 !text-neutral-500' : '',
                        ),
                    }}
                    id={itemId}
                    disabled={disabled}
                    name={name || itemId}
                />

                <label
                    htmlFor={itemId}
                    className={classNames(
                        'flex flex-row items-center w-full justify-between',
                        'cursor-pointer',
                        classContent,
                    )}
                >
                    <span className="inline">
                        { logo && isLogoExist(logo) && ((isPaymentMethod && !isAllBank) || isShipping) ? (
                            <Thumbor
                                magezon
                                src={logo}
                                width={68}
                                height={37}
                                quality={80}
                                alt={code}
                                storeConfig={storeConfig}
                                className="mr-2.5"
                                classContainer="!inline-block align-middle"
                            />
                        ) : null}

                        {shippingLabel}
                    </span>
                    {isGosend ? (
                        <>
                            {isGosend && isShippingMethodAvailable ? rightSide : null}
                        </>
                    ) : rightSide}
                </label>
            </div>
            { !loadingInfoGosendShipping && isGosend && dataInfoGosendShipping?.cmsBlocks?.items?.[0]?.content && (
                <div
                    className={classNames(
                        'ml-6 mobile:max-tablet:ml-0 payment-method-message !text-[15px] !leading-[22px]',
                        '!tracking-[.33px] !text-neutral-500 mt-[15px] -mb-[2px]',
                    )}
                >
                    <CmsRenderer
                        content={dataInfoGosendShipping.cmsBlocks.items[0].content}
                        storeConfig={storeConfig}
                    />
                </div>
            )}
            {form_message && isPaymentMethod ? (
                <Typography
                    variant="p-1"
                    className={classNames(
                        'ml-6 mobile:max-tablet:ml-0 payment-method-message !text-[15px] !leading-[22px]',
                        '!tracking-[.33px] !text-neutral-500 mt-[15px] -mb-[2px]',
                    )}
                >
                    {form_message}
                </Typography>
            ) : null}
            {!isGosend && isShipping && data && !loading && !error ? (
                <div
                    className={classNames(
                        'ml-6 mobile:max-tablet:ml-0 payment-method-message !text-[15px] !leading-[22px]',
                        '!tracking-[.33px] !text-neutral-500 mt-[15px] -mb-[2px]',
                    )}
                >
                    <CmsRenderer content={data?.cmsBlocks?.items[0]?.content} storeConfig={storeConfig} />
                </div>
            ) : null}
            {selected && (isCoreApi || isCoreApiXendit) && isCreditCard && isPaymentMethod ? (
                <div className="card-fieldset ml-6 mobile:max-tablet:ml-0">
                    <MidtransCoreApi
                        installment_options={term_options}
                        onValuesChange={(val) => onValuesCardChange(val)}
                        onError={(valError) => onErrorCard(valError)}
                        {...props}
                    />
                </div>
            ) : null}
            {selected && isCoreApiXendit && isJeniusPay ? (
                <div className="card-fieldset ml-6 mobile:max-tablet:ml-0 my-3">
                    <TextField
                        className="border border-neutral-300 w-full"
                        classWrapper="basis-full"
                        name="cashtag"
                        required
                        label="Cashtag"
                        value={cashtag}
                        onChange={(e) => handleChangeCashTag(e)}
                        maxLength={19}
                        absolute={false}
                        // hintProps={{
                        //     displayHintText: true,
                        //     hintType: 'error',
                        //     hintText: 'cashTag required ($johndoe)',
                        //     className: 'my-2',
                        // }}
                    />
                </div>
            ) : null}
            {isPaylater && selected ? (
                <div className="plans-options ml-6 mobile:max-tablet:ml-0 my-3">
                    <ul className="block">
                        {loadingPlans && !paylaterPlans ? (
                            <>
                                {[...Array(3)].map(() => (
                                    <li className="mb-4 [&:last-child]:mb-0">
                                        <Skeleton height={38} width={150} />
                                    </li>
                                ))}
                            </>
                        ) : (
                            <>
                                {paylaterPlans?.createPaylaterPlans?.options?.map((val) => (
                                    <>
                                        <li
                                            className={classNames(
                                                'py-2 px-4 min-w-[150px] max-w-[150px] mb-4 [&:last-child]:mb-0 text',
                                                'lowercase font-medium border rounded border-neutral-100',
                                            )}
                                        >
                                            <span>{val.total_recurrence}</span>
                                            {' '}
                                            <span>{val.interval}</span>
                                        </li>
                                    </>
                                ))}
                            </>
                        )}
                    </ul>

                </div>
            ) : null}
        </div>
    );
};

export default RadioDeliveryItem;
